import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import api from '../../lib/api';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../../components/ui/button';

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState('checking');
  const sessionId = params.get('session_id');

  useEffect(() => {
    let tries = 0;
    const poll = async () => {
      if (!sessionId) { setState('error'); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === 'paid') { await refresh(); setState('paid'); return; }
      } catch {}
      if (++tries > 12) { setState('timeout'); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#090A0F] p-6">
      <div className="max-w-md w-full rounded-2xl border border-white/10 bg-[#12141D] p-10 text-center">
        {state === 'checking' && <><Loader2 className="w-12 h-12 text-[#FF4D00] animate-spin mx-auto mb-4" /><div className="font-heading text-xl font-bold">Confirming your payment…</div></>}
        {state === 'paid' && <><CheckCircle2 className="w-12 h-12 text-emerald-400 mx-auto mb-4" /><div className="font-heading text-2xl font-bold">You are upgraded!</div><p className="text-slate-400 mt-2">Your new plan and minutes are active.</p><Link to="/app"><Button className="rounded-full mt-6">Go to dashboard</Button></Link></>}
        {(state === 'timeout' || state === 'error') && <><Loader2 className="w-12 h-12 text-slate-500 mx-auto mb-4" /><div className="font-heading text-xl font-bold">Still processing</div><p className="text-slate-400 mt-2">Your payment is being confirmed. Check billing in a moment.</p><Link to="/app/billing"><Button variant="outline" className="rounded-full mt-6 border-white/15 bg-white/5">Go to billing</Button></Link></>}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen grid place-items-center bg-[#090A0F] p-6">
      <div className="max-w-md w-full rounded-2xl border border-white/10 bg-[#12141D] p-10 text-center">
        <XCircle className="w-12 h-12 text-rose-400 mx-auto mb-4" />
        <div className="font-heading text-2xl font-bold">Checkout canceled</div>
        <p className="text-slate-400 mt-2">No charge was made. You can upgrade any time.</p>
        <Button onClick={() => nav('/app/billing')} className="rounded-full mt-6">Back to billing</Button>
      </div>
    </div>
  );
}
